import { type Dtos } from "@inrev/common";
import { useQuery } from "@tanstack/react-query";
import { useRequest } from "../../utils/request";
import { naicsCodesQueryKey } from "./naics-code.keys";

export const useFetchNaicsCodes = (params: Dtos.NaicsCode.List.Request, enabled = true) => {
	const { get } = useRequest();

	const { data, error, isLoading, isFetching, refetch } = useQuery({
		queryKey: naicsCodesQueryKey(params),
		queryFn: async () => {
			const search = new URLSearchParams({ versionYear: String(params.versionYear) });
			if (params.kind) search.set("kind", params.kind);
			if (params.parentId) search.set("parentId", params.parentId);
			return await get<Dtos.NaicsCode.List.Response>(`/v2/naics-codes?${search.toString()}`);
		},
		enabled,
		staleTime: 5 * 60 * 1000,
	});

	return {
		naicsCodes: data,
		naicsCodesError: error,
		naicsCodesIsLoading: isLoading,
		naicsCodesIsFetching: isFetching,
		refetchNaicsCodes: refetch,
	};
};
